import debug from 'bows';
import Selectr from 'selectr';

const log = debug('playworks-near-you');

class PlayworksNearYou {
    constructor(node, opts = {}) {
        this.node = node;
        this.config = {};
        this.defaults = {
            selectPlacement: 'top'
        }

        this.deactivating = false;

        for (let opt in this.defaults) {
            this.config[opt] = (opts.hasOwnProperty(opt) && opts[opt]) ? opts[opt] : this.defaults[opt];
        }

        if (this.node.dataset.select) {
            this.config.selectPlacement = this.node.dataset.select;
        }

        this.map = this.node.querySelector('.pny-map__wrap');
        this.aside = this.node.querySelector('.pny-map__aside');
        this.svg = this.node.querySelector('.pny-map__svg');
        this.contents = this.node.querySelector('.pny-map__contents');
        this.states = Array.prototype.slice.call(this.svg.querySelectorAll('g[data-state]'));
        this.dict = {};
        this.active = null;
        this.activeClass = 'pny-map__state--active';

        this.select = document.createElement('select');
        this.select.className = 'pny-map__state-select';
        this.states.forEach((state) => {
            let opt = document.createElement('option');
            opt.value = state.getAttribute('data-state');
            opt.appendChild(document.createTextNode(state.getAttribute('data-name')));
            this.select.appendChild(opt);
        });

        this.selectrClasses = ['pny-map__state-select'];

        switch (this.config.selectPlacement) {
            case 'top':
                this.node.parentNode.insertBefore(this.select, this.node);
                this.selectrClasses.push('pny-map__state-select--top');
                break;
            case 'below':
                this.contents.parentNode.insertBefore(this.select, this.contents);
                // this.aside.appendChild(this.select);
                // this.select.insertAdjacentHTML('beforebegin', '<p class="pny-map__state-select-label">Select a state</p>');
                this.selectrClasses.push('pny-map__state-select--below');
                break;
            default:
                this.node.appendChild(this.select);
                this.selectrClasses.push('pny-map__state-select--hidden');
        }

        if (this.select.parentNode) {
            this.selectr = new Selectr(this.select, {
                clearable: true,
                defaultSelected: false,
                placeholder: 'Select a state...',
                searchable: true,
            });

            this.selectr.on('selectr.change', (option) => {
                log('selectr.change', option, this.selectr, this.deactivating);
                if (!this.deactivating) {
                    this.activate(option.value);
                }
                this.deactivating = false;
            });

            this.selectr.on('selectr.deselect', (option) => {
                this.deactivating = true;
                this.deactivate();
            });

            this.selectrClasses.forEach((cl) => this.selectr.container.classList.add(cl));
        }

        this.select.addEventListener('change', (e) => {
            this.activate(e.target.value);
        });

        this.resize();
        window.addEventListener('site.resize', this.resize.bind(this));

        this.states.forEach((node) => {
            const state = node.getAttribute('data-state');
            this.dict[state] = {
                node: node,
                content: this.node.querySelector(`.pny-map__state[data-state="${state}"]`),
                tri: this.node.querySelector(`.pny-map__state[data-state="${state}"] .pny-map__state-tri`)
            }
            node.addEventListener('click', () => {
                this.selectr.setValue(state);
                // this.activate(state);
            });
            this.dict[state].content.addEventListener('click', () => {
                this.deactivate(true);
            });
        });
    }

    resize() {
        this.svg.style.width = `${this.map.offsetWidth}px`;
        this.svg.style.height = `${Math.ceil(this.map.offsetWidth * .618)}px`;

        if (this.active) {
            this.position(this.active);
        }
    }

    position(state) {
        log('position', state);
        const node = this.dict[state].node;
        const content = this.dict[state].content;
        const nodeRect = node.getBoundingClientRect();
        const contentRect = content.getBoundingClientRect();
        const mapRect = this.map.getBoundingClientRect();
        const adjustX = parseInt(node.getAttribute('data-adjust-x'), 10);
        const adjustY = parseInt(node.getAttribute('data-adjust-y'), 10);

        let left = nodeRect.left - mapRect.left - (contentRect.width / 2) + (nodeRect.width / 2) + adjustX;
        let top = nodeRect.top - mapRect.top - contentRect.height + adjustY;
        let triOffset = 0;
        let offTop = mapRect.top + top;


        if (left < 10) {
            triOffset = Math.round(10 + Math.abs(left)) * -1;
            left = 10;
        } else if (left + content.offsetWidth > document.body.clientWidth) {
            triOffset = left - (document.body.clientWidth - 10 - content.offsetWidth);
            left = document.body.clientWidth - 10 - content.offsetWidth;
        }


        this.dict[state].tri.style.opacity = 1;
        if (offTop < 0) {
            top = top + Math.abs(offTop) + 10;
            let cr = (contentRect.height * 2) + top + mapRect.top;
            let boundry2 = nodeRect.top + (nodeRect.height * 2);

            if (cr > boundry2) {
                this.dict[state].tri.style.opacity = 0;
            }
        }

        content.style.left = `${left}px`;
        content.style.top = `${top}px`;


        if (triOffset !== 0) {
            this.dict[state].tri.style.transform = `translateX(${triOffset}px)`;
        }
    }

    activate(state, setSelectr = false) {
        log('activate', state, setSelectr, this.deactivating);

        if (this.dict[state]) {
            if (this.active) {
                this.deactivate();
            }

            this.position(state);

            if (this.select) {
                this.select.value = state;
            }

            this.dict[state].node.setAttribute('class', this.activeClass);
            this.dict[state].content.classList.add(this.activeClass);

            if (this.select && setSelectr) {
                this.selectr.setValue(state);
            }

            // this.select.value = state;
            this.active = state;
        }

    }

    deactivate(setSelectr = false) {
        log('deactivate', this.active);
        if (this.active) {
            this.dict[this.active].node.removeAttribute('class');
            this.dict[this.active].content.classList.remove(this.activeClass);
            this.active = null;
            if (this.select && setSelectr) {
                this.selectr.clear();
            }
        }
    }
}

export default PlayworksNearYou;